/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Invite } from "../types/Invite";
export const Request = core.serialization.list(Invite);
